//NBL1_Staff Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import settings from "../Settings/NBL1_Settings"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import store from "../../veux/store"

let Countries, StaffStatus, Clubs, Conference
let step1, step2


// NBL1 Staff Step Schema
const Load_NBL1_Staff_Steps = () => {
    return {
        Portal: '2025 NBL1 Staff',
        MainColor: "#f5924c",
        Logo: require(`../../assets/${Conference.logo}`),
        Title: `<h2>Mitsubishi ${Conference.Name} 2025 Staff Registration Form</h2>`,
        Description: `I HEREBY APPLY to be registered with ${Conference.Organisation}
                            (${Conference.abbrev}) for the 2025 ${Conference.Name} season. I acknowledge
                            that my information will be retained and used by ${Conference.abbrev}
                            and the NBL to meet its obligations in administering the league and
                            to ensure the registered person can be contacted when required for Tribunal,
                            Integrity or COVID related matters.
                            <br><br>
                                All registered persons should note, in accordance with the Basketball Australia
                                (BA) National Integrity Framework. BA may share personal information relating
                                to Participants with Betting Operators, law enforcement agencies, government
                                agencies or other sporting organisations to prevent and investigate match-fixing
                                incidents.
                                <br></br>
                                <b>Please note all submitted registrations are PENDING approval subject to accreditation.`,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Rego',
                valid: true,
                information: '',
                Schema: {
                    DOB: {
                        type: 'text',
                        ext: 'date',
                        locale: 'en',
                        label: `Date of Birth (${store.getters.getdateFormat})`,
                        outlined: true,
                        dense: true,
                        mask: store.getters.getdateMask,
                        rules: [rules.requiredMsg('Date of Birth is Required'),
                        rules.minAge(`The NBL1 has a minimum age in all divisions that a coach
                                    must turn at least 14 years of age during
                                    the year in which the coach seeks to register.
                                    You are not eligible to register for this current competition year`, '2010-01-01')],
                        class: 'mx-1 px-1',
                        // onInput: (ev, portal) => { },
                        OUG: { Contacts: { Field: "date_of_birth" } }
                    },
                    birthCountry: {
                        id: "3394",
                        type: 'select',
                        label: 'Country of Birth?',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Country of Birth is Required')],
                        class: 'mx-1 px-1',
                        items: Countries,
                        OUG: { Contact_Details: { Type: 3394, Action: "Unique" } }
                    },
                    StaffStatus: {
                        id: "3373",
                        type: "select",
                        label: "Staff Status",
                        outlined: true,
                        dense: true,
                        class: 'mx-1 px-1',
                        rules: [rules.requiredMsg('Staff Status is Required')],
                        items: StaffStatus,
                        value: '',
                        OUG: { Contact_Details: { Type: 3373, Action: "Unique" } }
                    },
                    CompSelect: {
                        "type": "select",
                        "label": "Competition Selection",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Competition Selection is Required')],
                        class: 'mx-1 px-1',
                        items: settings.CompType,
                        onInput: async (ev) => {
                            Clubs = await settings.LookupTeams({
                                State_Champs: Conference.Code_id,
                                Gender: functions.getCompGender(ev.data.CompSelect)
                            })
                            ev.schema.Teams.items = Clubs
                            if (Conference.Code_id === 3031) {
                                ev.schema.RSLLogo.hidden = false
                                ev.schema.RSLVet.hidden = false
                                ev.schema.RSLVet.rules = [rules.requiredMsg('Served in the Australian Defence Forces is required')]
                                ev.schema.RSLVetOther.hidden = false
                                ev.schema.RSLVetOther.rules = [rules.requiredMsg('Family who Served in the Australian Defence Forces is required')]
                            } else {
                                ev.schema.RSLLogo.hidden = true
                                ev.schema.RSLVet.hidden = true
                                ev.schema.RSLVet.rules = []
                                ev.schema.RSLVetOther.hidden = true
                                ev.schema.RSLVetOther.rules = []
                            }
                        }
                    },
                    Teams: {
                        type: "select",
                        label: "Which Club are you registering for?",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Club is Required')],
                        class: 'mx-1 px-1',
                        items: Clubs,
                        returnObject: true,
                        itemText: 'Detail',
                        Role: null,
                        Accreditation: null,
                        AccredStart: '',
                        AccredEnd: '',
                        noDataText: 'Please Enter Competition Selection First',
                        AccredTeam: Conference.Code_id,
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    },
                    Position: {
                        type: "select",
                        label: "Staff Position",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Staff Position is Required')],
                        class: 'mx-1 px-1',
                        items: settings.StaffRoles,
                        value: '',
                        onInput: async (ev) => {
                            let index = settings.StaffRoles.findIndex((ele) => {
                                return (ele == ev.data.Position);
                            })
                            ev.schema.Teams.Role = settings.StaffRoleids[index]
                            ev.schema.Teams.Accreditation = settings.LoadExtAccreds(Conference.Code_id).StaffAccredids[index]
                        },
                        OUG: { Contact_Details: { Type: 346, Action: "SingleDesc" } }
                    },
                    RSLLogo: {
                        type: 'img',
                        hidden: true,
                        src: `https://admin.ownurgoal.net.au/_lib/file/OUGImages/RSL_Vic_Logo.png`,
                        width: "50%",
                        contain: true,
                        class: "ma-auto",
                    },
                    RSLVet: {
                        addText: " in the Australian Defence Forces",
                        type: "select",
                        label: "I have served in the Australian Defence Forces",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: ["No - I have not Served", "Yes - I have Served", "Rather Not Say - if I Served"],
                        value: '',
                        col: 12,
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">
                                <b>As part of BV's partnership with RSL Victoria, please can you advise if you have served in the Australian Defence Forces including Reservists</b>
                                </p>`,
                        OUG: {
                            Contact_Details: {
                                Type: 3865,
                                Action: "SingleDesc",
                                Description: 'Served in the Australian Defence Forces',
                            }
                        }
                    },
                    RSLVetOther: {
                        addText: "  to family member served in the Australian Defence Forces",
                        type: "textarea",
                        label: "Family members who served",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: ["No", "Rather Not Say", "Spouse", "Parent", "Grandparent", "Sibling", "Child", "Aunty", "Uncle", "Other"],
                        value: '',
                        col: 12,
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">
                            <b>Has a member of your family (spouse, parent, grandparent, sibling, child, aunty or uncle) ever served in the Australia Defence Forces including Reservists?
                        </p>`,
                        OUG: {
                            Contact_Details: {
                                Type: 3865,
                                Action: "SingleDesc",
                                Description: 'Family Served in the Australian Defence Forces',
                            }
                        }
                    },
                },
                PreStep: (thisStep, portal) => {
                    let { Schema } = thisStep
                    store.getters.birthCountry ? portal.Model.birthCountry = store.getters.birthCountry : null
                    store.getters.birthCountry ? Schema.birthCountry.value = store.getters.birthCountry : null
                    store.getters.StaffStatus ? portal.Model.StaffStatus = store.getters.StaffStatus : null
                    store.getters.StaffStatus ? Schema.StaffStatus.value = store.getters.StaffStatus : null
                },
            },
            // Step 4
            {
                stepno: 4,
                title: 'Integrity',
                valid: true,
                information: `<div style="padding-bottom: 25px; line-height: 200%">
                    All Staff must complete or provide proof of completion for the following E-Learning sessions provided by Sport Integrity Australia and Basketball Australia to complete your registration and compete in ${Conference.Name}.
                    <br><br>
                    <h4>Sport Integrity Australia</h4>
                    1. <a href="https://elearning.sportintegrity.gov.au/login/index.php" target="_blank">SIA Anti Doping Fundamentals Course</a>
                    - <b>COMPLETE ONCE (NEW TEAM STAFF/TEAM STAFF THAT HAVE NOT COMPLETED)</b>
                    <br>
                    2. <a href="https://elearning.sportintegrity.gov.au" target="_blank">SIA 2025 Annual Update</a>
                    (after completion of SIA Anti-Doping Fundmentals Course) - <b>COMPLETE ANNUALLY</b>
                    <br><br>
                    
                    <h4>Basketball Australia</h4>
                    3. <a href="https://basketballaustralia.etrainu.com/training/?event=course.purchase&bundleID=3F0F3FD7-A729-42C2-9F88-41CA9C6B5C97&secret=5E2104A0-BE72-CB0A-62F8BC01C42F51F2" target="_blank">BA Gambling and Match-Fixing Course</a>
                    - <b>COMPLETE ONCE (NEW TEAM STAFF/TEAM STAFF THAT HAVE NOT COMPLETED)</b>
                    <br>
                    4. BA Face to Face Integrity Session - <b>COMPLETE ANNUALLY</b>
                    <br><br>
                    If you have already completed these courses and need to retrieve your proof of completion, please click the relevant link below:
                    <br>
                    <a href="https://elearning.sportintegrity.gov.au/login/index.php" target="_blank">Retrieve SIA Anti-Doping & Annual Update Badges</a>
                    <br>
                    <a href="https://basketballaustralia.etrainu.com/training/index.cfm?event=page.login" target="_blank">Retrieve BA Gambling and Match-Fixing Certifcate</a>
                    ${(Conference.Code_id == 3031) ? `<br><br><h4>Basketball Victoria</h4>5. Basketball Victoria Coaching Certificate - BV Association Coaches Course for Head Coaches or the Club Coaches Course for Asst Coaches<br>` : ``}
                    </div>`,
                Model: {},
                Schema: {
                    MatchFixing: {
                        type: 'file',
                        label: 'BA Integrity Certificate',
                        multiple: false,
                        outlined: true,
                        hidden: store.getters.integrity,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: (store.getters.integrity) ? [] : [rules.requiredMsg('Introduction to Match-Fixing Certificate is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "BA Introduction to Match-Fixing",
                            }
                        },
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">Basketball Australia Gambling and Match Fixing Course Certificate – (Please upload a screenshot of your Certificate <a href="https://admin.ownurgoal.net.au/_lib/file/doc/GamblingMatchFixingExample.jpg" target="blank">Click Here for Example</a>)</p>`
                    },
                    haveMatchFixing: {
                        type: 'text',
                        dense: true,
                        disabled: true,
                        hidden: !store.getters.integrity,
                        class: 'mx-1 px-1',
                        Startslot: `<H4 style="text-align:center;color:red">We already have a copy of your BA Integrity Gambling & Match Fixing Certificate</H4>`
                    },
                    AnnualUpdate2025: {
                        type: 'file',
                        label: 'Annual Update 2025',
                        multiple: false,
                        outlined: true,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: [rules.requiredMsg('Annual Update 2025 Certificate is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "Annual Update 2025 Certificate",
                            }
                        },
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">SIA badges – (Please upload a screenshot of your SIA Badges page <a href="https://admin.ownurgoal.net.au/_lib/file/doc/SIAExample.jpg" target="blank">Click Here for Example</a>, which must show the SIA Anti-Doping Fundamentals badge, AS WELL AS the SIA 2025 annual update badge)</p>`
                    },
                    CoachingCourse: {
                        type: 'file',
                        label: 'Coaching Course Certificate',
                        multiple: false,
                        outlined: true,
                        hidden: Conference.Code_id == 3033 || Conference.Code_id == 3034,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: (Conference.Code_id == 3033) ? [] : [rules.requiredMsg('Coaches Course Certificate is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "Coaching Course Certificate",
                            }
                        },
                    },
                    MedicalCourse: {
                        type: 'file',
                        label: 'Medical Course Certificate',
                        multiple: false,
                        outlined: true,
                        hidden: true,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: [rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "Medical Course Certificate",
                            }
                        },
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">Sport Integrity Medical Practitioners Course – (Use this link to access the site <a href="https://elearning.sportintegrity.gov.au" target="blank">Click Here</a>)</p>`
                    },
                    haveMedicalCourse: {
                        type: 'text',
                        dense: true,
                        disabled: true,
                        hidden: !store.getters.medical,
                        class: 'mx-1 px-1',
                        Startslot: `<H4 style="text-align:center;color:red">We already have a copy of your Medical Course Certificate</H4>`
                    },
                    BAIntegrity: {
                        type: 'checkbox',
                        label: `Please check this box if you agree to abide by Basketball Australia's National Integrity Framework`,
                        color: "primary",
                        value: "Agree to BA National Integrity Framework",
                        rules: [rules.requiredMsg('Confirmation of acceptance of BA Integrity Framework is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Integrity Requirements</h3>`,
                        Endslot: `<h4 class="slot">
                                        I agree to abide with the BA National Integrity Framework, BA may share personal information relating to Participants with Betting Operators, law enforcement agencies, government agencies or other sporting organisations to prevent and investigate match-fixing incidents.
                                        <br>
                                            <a href="https://australia.basketball/integrity/" target="_blank">Click here to review National Integrity Framework</a>
                                    </h4>`,
                        OUG: { Answer: true }
                    },
                },
                PreStep: (thisStep, portal) => {
                    let { Schema } = thisStep
                    switch (portal.Model.Position) {
                        case 'Team Manager':
                            Schema.CoachingCourse.hidden = true
                            Schema.CoachingCourse.rules = []
                            Schema.MedicalCourse.hidden = true
                            Schema.MedicalCourse.rules = []
                            Schema.haveMedicalCourse.hidden = true
                            break;

                        case 'Medical Staff':
                            Schema.CoachingCourse.hidden = true
                            Schema.CoachingCourse.rules = []
                            Schema.MedicalCourse.hidden = true
                            Schema.MedicalCourse.rules = []
                            Schema.haveMedicalCourse.hidden = true
                            // Schema.MedicalCourse.hidden = store.getters.medical
                            // Schema.MedicalCourse.rules = (store.getters.medical) ? [] : [rules.requiredMsg('Medical Course Certificate is Required')]
                            // Schema.haveMedicalCourse.hidden = !store.getters.medical
                            break;

                        default:
                            Schema.MedicalCourse.hidden = true
                            Schema.MedicalCourse.rules = []
                            Schema.haveMedicalCourse.hidden = true
                            Schema.CoachingCourse.hidden = Conference.Code_id == 3033 || Conference.Code_id == 3034
                            Schema.CoachingCourse.rules = (Conference.Code_id == 3033 || Conference.Code_id == 3034) ? [] : [rules.requiredMsg('Coaches Course Certificate is Required')]
                            break;
                    }
                },
            },
            //Step 5
            {
                stepno: 5,
                title: 'Confirmation',
                valid: true,
                information: ``,
                Model: {},
                Schema: {
                    COVID: {
                        type: 'checkbox',
                        label: `I have read and agree to abide to any ${Conference.Organisation} determinations on participation eligibility at any point relatable to COVID 19 or other.`,
                        color: "primary",
                        value: "Agree to abide by COVID requirements",
                        hidden: (Conference.Code_id === 3034),
                        rules: (Conference.Code_id === 3034) ? [] : [rules.requiredMsg('Confirmation of acceptance of COVID Requirements is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>COVID Requirements</h3>`,
                        Endslot: `<a href=${settings.LoadExtForm('COVID', Conference.Code_id)} target="blank">
                                        ${Conference.Organisation} Vaccination Requirements</a>`,
                        OUG: { Answer: true }
                    },
                    Participate: {
                        type: 'checkbox',
                        label: `I have read and agree to the terms and conditions of participation 
                            in NBL1. As laid out in the ${Conference.Name} Rules`,
                        color: "primary",
                        value: "Agree to all Terms and Conditions for NBL1",
                        rules: [rules.requiredMsg('Confirmation of acceptance of Terms and Conditions is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Participation Requirements</h3>`,
                        Endslot: `<a href=${settings.LoadExtForm('T&Cs', Conference.Code_id)} target="blank">
                                        ${Conference.Name} Rules</a>`,
                        OUG: { Answer: true }
                    },
                    staffuniformConfirm: {
                        type: 'checkbox',
                        label: `I will abide by NBL1 dress standard requirements and am aware fines are issued for non compliance`,
                        color: "primary",
                        value: "Agree to abide by NBL1 Dress Standards",
                        rules: [rules.requiredMsg('Confirmation of Staff Garment Policy is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Staff Clothing Requirements</h3>
                                    <br>
                                        <h4>(a)	Coaches</h4>
                                        <i><ul>Coaches must wear a collared shirt. If this is a polo shirt
                                            then it must be an Association branded polo. During colder weather
                                            it is understandable that this will be covered by a jacket/hoodie that must
                                            be either an Association tracksuit jacket or other jacket that fits
                                            the general description of business casual wear. Denim, shorts or
                                            tracksuit pants are not permitted for Coaches and their Assistants.
                                            Shoes must be clean and tidy. Basketball shoes or other runners are
                                            not permitted.</ul><br></i>
                                        <h4>(b)	Team Managers</h4>
                                        <i><ul>Team managers should be dressed appropriately and neatly in association branded clothing
                                        </ul></i>`,
                        OUG: { Answer: true }
                    },
                    showUniformDetails: {
                        type: 'img',
                        hidden: false,
                        src: `${settings.LoadExtForm('Uniform', Conference.Code_id)}`,
                        // height: "800px",
                        // width: "100%",
                        //maxHeight: 1366,
                        //maxWidth: 768
                        contain: true,
                        class: "ma-2"
                    },
                    uniformConfirm: {
                        type: 'checkbox',
                        label: `I am aware of the players garment compression policy and will ensure all players are educated and aligned with requirements.`,
                        color: "primary",
                        value: "Agree to enforce the Compression Garment Policy with my players",
                        rules: [rules.requiredMsg('Confirmation of Compression Garment Policy is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Uniform Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    foreignPlayer: {
                        type: 'checkbox',
                        label: `I agree that if I do not currently have Australian Citizenship, I will gain Basketball Australia approval each competition year so I am eligible to coach in any NBL1 match.`,
                        color: "primary",
                        value: "I Confirm I meet Foreign Coach Conditions",
                        rules: [rules.requiredMsg('Confirmation of Foreign Coach Requirement is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Foreign Coach Requirements</h3>`,
                        Endslot: `<a href="https://www.australia.basketball/get-involved/pathways/immigration" target="blank">
                            Basketball Australia Immigration Policy (non current Australian Citizens)</a>`,
                        OUG: { Answer: true }
                    },
                    cocConfirm: {
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the ${Conference.Organisation} Code of Conduct`,
                        color: "primary",
                        value: "Confirm I will adhere to NBL1 Code of Conduct",
                        rules: [rules.requiredMsg('Confirmation of Code of Conduct is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Code of Conduct Requirements</h3>`,
                        Endslot: `<a href=${settings.LoadExtForm('COC', Conference.Code_id)} target="blank">
                                            ${Conference.Organisation} Code of Conduct</a>`,
                        OUG: { Answer: true }
                    },
                    Concussion: {
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the ${Conference.Organisation} Concussion Protocols`,
                        color: "primary",
                        value: "Confirm I will adhere to NBL1 Concussion Protocols",
                        rules: (Conference.Code_id === 3033 || Conference.Code_id === 3032) ? [] : [rules.requiredMsg('Confirmation of NBL1 Concussion Protocols is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        hidden: (Conference.Code_id === 3033 || Conference.Code_id === 3032),
                        Startslot: `<h3>Concussion Requirements</h3>`,
                        Endslot: `<a href=${settings.LoadExtForm('Concussion', Conference.Code_id)} target="blank">
                                            ${Conference.Organisation} Concussion Protocols</a>`,
                        OUG: { Answer: true }
                    },
                    useImages: {
                        type: 'checkbox',
                        label: `I acknowledge that ${Conference.abbrev},
                                        ${Conference.Name} and my Club may use images,
                                        video, or similar of me for the promotion of the League
                                        and the Club.`,
                        color: "primary",
                        value: "Acknowledge use of my Images and Video",
                        rules: [rules.requiredMsg('Use of Images confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Images Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    attendTribunal: {
                        type: 'checkbox',
                        label: `I undertake to attend meetings of the ${Conference.Organisation} Tribunal whenever required to do so and consent to the subsequent reporting of the proceedings of such meetings and hearings.`,
                        color: "primary",
                        value: "Agree to attend Tribunal or other meetings",
                        rules: [rules.requiredMsg('Agreement to Attend is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Tribunal Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    infoAccurate: {
                        type: 'checkbox',
                        label: 'I confirm that I have provided infomation honestly and that it is both true and accurate.',
                        color: "primary",
                        value: "Confirm information all honest and correct",
                        rules: [rules.requiredMsg('Accurate Information confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Information Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                },
            },
            // Step 6
            {
                stepno: 6,
                title: 'Finalisation',
                valid: true,
                information: `Thank you for your submitted registration for the 2025 NBL1 season.</br>
                                    Please note this submitted registration is <b>PENDING APPROVAL</b> from the league and will be reviewed.<br></br>
                                    You and your association delegate will receive an email notification once this has been approved by the league and
                                    you will then be assigned to the teams roster and be able to part of team staff on game day as an eligible Staff Member.<br></br>
                                    <hr><br></br>
                                        Please stay up to date with all NBL1 news and information throughout the season on the <a href="https://nbl1.com.au/" target="blank">NBL1 website</a><br></br>`,
                Model: {},
                Schema: {}
            }
        ]
    }
}

export default {

    LoadSchema: async (Parameters) => {
        Conference = settings.ConfDetails.find((ele) => {
            return Parameters.Conference == ele.Code_id;
        })
        step1 = await Verification.LoadSchema(1)
        step2 = await Base_Details.LoadSchema(2)
        Countries = await functions.GetCountries();
        StaffStatus = await functions.GetCodeBy({ Type: "NBL1 Playing Status" });
        return Load_NBL1_Staff_Steps()
    },

}